import ImageProps, { SettingsPanelEditInputProps } from "../../types/imageStudio/images";
import { stripKnownImageStudioExtensions } from "../aiModels/apiImageStudio";
import { colorFilterList } from "./colorFilter";

export const changeSettingsPanelEditInput = (currentSeetings: SettingsPanelEditInputProps, selectedImg: ImageProps | null,newImg: ImageProps): SettingsPanelEditInputProps => {
    return {
        ...currentSeetings,
        title: selectedImg && selectedImg.file 
            ?   stripKnownImageStudioExtensions(selectedImg.file.name)
            :   selectedImg && selectedImg.title
                ? stripKnownImageStudioExtensions(selectedImg.title)
                : newImg.file?.name
                    ? stripKnownImageStudioExtensions(newImg.file.name)
                    : 'image',
        imgSrc: newImg.src,
        baseImgSrc: newImg.src,
        imgFile: newImg.file,
        width: newImg.width,
        height: newImg.height,
        rotation: currentSeetings?.rotation ?? 0
    };
};

export const getSettingsPanelEditInputFromFile = (img: ImageProps): SettingsPanelEditInputProps => {
    return {
        aspectRatio: '1:1 (quadratic)',
        colorFilterName: 'No Filter',
        colorFilterData: colorFilterList[0],
        flipHorizontal: false,
        flipVertical: false,
        rotation: 0,
        cropRect: null,
        originalImgSrc: img?.src ?? '',
        baseImgSrc: img?.src ?? '',
        imgSrc: img?.src ?? '',
        imgFile: img.file ?? null,
        thumbnail: null,
        createdAt: new Date(),
        width: img?.width ?? 0,
        height: img?.height ?? 0,
        title: img?.title ?? '',
        transparency: {
            color: '#ffffff',
            alpha: 1,
            tolerance: 40
        },
        transparencyTransition: {
            color: '#ffffff',
            alpha: 1,
            tolerance: 40
        }
    };
};